import type { ReactNode } from 'react'

type Color = 'indigo' | 'emerald' | 'gray'

const colors: Record<Color, string> = {
  indigo: 'bg-slate-700',
  emerald: 'bg-emerald-600',
  gray: 'bg-gray-400',
}

export function IconBadge({ color = 'indigo', lg = false, children }: { color?: Color; lg?: boolean; children: ReactNode }) {
  const size = lg ? 'w-10 h-10' : 'w-8 h-8'
  return (
    <span className={`inline-flex ${size} ${colors[color]} rounded-lg items-center justify-center shrink-0 text-white`}>
      {children}
    </span>
  )
}
